export enum ContactType {
    Unknown = 0,
    Client = 100,
    Project = 200,
    Supplier = 300,
}
